export default __webpack_public_path__ + "static/media/motion_paused.bcf57af5.svg";